import { cn, iaRa } from 'lib/helpers/utility';

import DocText from 'components/shared/DocumentSheet/DocText';
import { DOC_TEXT } from 'components/shared/DocumentSheet/lib/docStyles';

const InvoiceDocBilledTo = ({ party, date, dateLabel = 'Due date', action }) => (
  <div className="mt-[14px] flex items-start justify-between gap-x-6 xs:flex-col xs:gap-y-3">
    <div className="min-w-0">
      <DocText variant="label" size="small" className={DOC_TEXT.microLabel}>
        {String(party?.label || 'Billed to').toUpperCase()}
      </DocText>
      {action || (
        <>
          {party?.name && (
            <DocText className={cn(DOC_TEXT.fieldValue, 'mt-0.5')}>{party.name}</DocText>
          )}
          {iaRa(party?.lines).map((line, index) => (
            <DocText key={`party-line-${index}`} size="xs" className={DOC_TEXT.meta}>
              {line}
            </DocText>
          ))}
        </>
      )}
    </div>
    {date && (
      <div className="shrink-0 whitespace-nowrap text-right xs:text-left">
        <DocText
          variant="label"
          size="small"
          className={cn(DOC_TEXT.microLabel, 'text-right xs:text-left')}>
          {dateLabel.toUpperCase()}
        </DocText>
        <DocText className={cn(DOC_TEXT.fieldValue, 'mt-0.5 text-right xs:text-left')}>
          {date}
        </DocText>
      </div>
    )}
  </div>
);

export default InvoiceDocBilledTo;
